import React from 'react';
import { Pie } from '@ant-design/charts';
import PageTopWrapper from './page-top-wrapper';
import { Typography } from 'antd';

interface IProps {
    dataReport: any;
}
const ShippingPie: React.FC<IProps> = ({ dataReport = {} }) => {
    const config = {
        appendPadding: 10,
        data: dataReport?.listCountShiping || [],
        angleField: 'total',
        colorField: 'name',
        radius: 0.9,
        label: {
            type: 'inner',
            offset: '-30%',
            content: function content(_ref: any) {
                const percent = _ref.percent;
                return ''.concat(`${_ref.total} (${(percent * 100).toFixed(0)}%)`);
            },
            style: {
                fontSize: 14,
                textAlign: 'center',
            },
        },
        interactions: [{ type: 'element-active' }],
    };
    return (
        <div>
            <PageTopWrapper leftContent={<Typography.Title level={5}>Lượt checkin theo loại phòng</Typography.Title>} />
            <Pie {...config} className="chart-status" />
        </div>
    );
};

export default ShippingPie;
